import {
    DexResultsSummaryView,
    DexResultView,
    DexQueryView,
    DexQueryAndResultsView,
} from '@mark43/dex-api';
import { Divider, Box } from '@cad-arc';
import { DexResultItem } from './dex-result-item';
import { ResultsSummaryItem } from './dex-result-summary-item';
import { useSelectDexResults } from './use-select-dex-results';
import { QuerySummary } from './query-summary';
import { resultsHaveHit } from './utils';
import { useDexResults } from './use-dex-results';

export function DexResultItems({
    outgoingMessageId,
    results,
    query,
    resultsSummaryView,
    cascadedQueries,
    selectedResultId,
    selectedSummaryId,
    extraPaddingLeft,
    nestingLevel = 0,
}: {
    outgoingMessageId: number;
    results: DexResultView[];
    query?: DexQueryView;
    resultsSummaryView?: DexResultsSummaryView;
    cascadedQueries?: DexQueryAndResultsView[];
    selectedResultId?: number;
    selectedSummaryId?: number;
    extraPaddingLeft?: string;
    nestingLevel?: number;
}) {
    const { dexResultsStore } = useDexResults();
    const { selectDexResult, selectDexResultsSummary } = useSelectDexResults(dexResultsStore);
    const hasHits = resultsHaveHit(results);

    return (
        <>
            {resultsSummaryView && (
                <ResultsSummaryItem
                    isSelected={outgoingMessageId === selectedSummaryId}
                    onClick={() => selectDexResultsSummary(outgoingMessageId)}
                    resultsSummaryView={resultsSummaryView}
                />
            )}
            {query && (
                <Box>
                    <Divider />
                    <QuerySummary query={query} hasHits={hasHits} />
                </Box>
            )}
            {results.map((result) => (
                <Box key={result.incomingMessageId} paddingLeft={extraPaddingLeft ?? '0px'}>
                    <DexResultItem
                        key={result.incomingMessageId}
                        result={result}
                        isSelected={result.incomingMessageId === selectedResultId}
                        onClick={() => selectDexResult(result.incomingMessageId)}
                        nestingLevel={nestingLevel}
                    />
                    <DexResultItems
                        outgoingMessageId={outgoingMessageId}
                        results={result.childDexResultViews}
                        selectedResultId={selectedResultId}
                        nestingLevel={nestingLevel + 1}
                        extraPaddingLeft={extraPaddingLeft ?? '0px'}
                    />
                </Box>
            ))}
            {!!cascadedQueries?.length &&
                cascadedQueries.map((cascadedQuery) => {
                    const cascadedQueryHasHits = resultsHaveHit(cascadedQuery.results);
                    return (
                        <Box key={cascadedQuery.query.outgoingMessageId}>
                            <Divider />
                            <QuerySummary
                                query={cascadedQuery.query}
                                hasHits={cascadedQueryHasHits}
                            />
                            {cascadedQuery.results.map((cascadedResult) => (
                                <Box
                                    key={cascadedResult.incomingMessageId}
                                    paddingLeft={extraPaddingLeft ?? '0px'}
                                >
                                    <DexResultItem
                                        key={cascadedResult.incomingMessageId}
                                        result={cascadedResult}
                                        isSelected={
                                            cascadedResult.incomingMessageId === selectedResultId
                                        }
                                        onClick={() =>
                                            selectDexResult(cascadedResult.incomingMessageId)
                                        }
                                        nestingLevel={nestingLevel}
                                    />
                                    <DexResultItems
                                        outgoingMessageId={cascadedQuery.query.outgoingMessageId}
                                        results={cascadedResult.childDexResultViews}
                                        selectedResultId={selectedResultId}
                                        nestingLevel={nestingLevel + 1}
                                        extraPaddingLeft={extraPaddingLeft ?? '0px'}
                                    />
                                </Box>
                            ))}
                        </Box>
                    );
                })}
        </>
    );
}
